import React from "react";
import { useHistory } from "react-router-dom";
import MainLayout from "../../layout/MainLayout";
import DefaultHeader from "../../layout/Header/DefaultHeader";
import CancerMainFooter from "../../layout/Footer/CancerMainFooter";
import FormList from "./FormList";

const ProstateResult = ({
  cancer = "전립선암",
  onPageChange,
  onLinkHome,
  score,
  onChange,
}) => {
  const history = useHistory();
  // 다음으로 페이지 이동
  const handlePageMove = () => {
    history.push("/prostatecancer/video");
  };
  return (
    <MainLayout
      header={<DefaultHeader cancer={cancer} />}
      footer={<CancerMainFooter name1="시청하기" onClick1={handlePageMove} />}
    >
      <FormList
        cancer={cancer}
        onPageChange={onPageChange}
        onLinkHome={onLinkHome}
        score={score}
        onChange={onChange}
      />
    </MainLayout>
  );
};

export default ProstateResult;
